













import { computed, defineComponent }   from '@vue/composition-api';
import cSectionTitle                   from '@/components/section-title/section-title.component.vue';
import cPlusButton                     from '@/components/custom/buttons/plus-button/plus-button.component.vue';
import { useGroupQuotationList }       from '@/views/group-quotation-list/hooks/use-group-quotation-list.hook';
import { useGlobals }                  from '@/hooks/use-globals';
import { Computed }                    from '@/types';
import { getViewStorePath }            from '@/store/store.helpers';
import cGroupQuotationListTable        from './components/group-quotation-list-table/group-quotation-list-table.component.vue';
import { name as vGroupQuotationList } from './group-quotation-list.route';

export default defineComponent({
  name: 'vGroupQuotationList',
  components: {
    cSectionTitle,
    cPlusButton,
    cGroupQuotationListTable,
  },
  setup() {
    const { store, i18n } = useGlobals();
    const { getLocalTranslation, goToGroupQuotationEditView } = useGroupQuotationList();

    const buttonText: Computed<string> = computed(() => i18n.t(`${store.state.i18n.GLOBAL_PATH}.buttons.createNew`, [ 'quote' ])
      .toString());

    const onClick = (): void => {
      goToGroupQuotationEditView();
    };

    store.dispatch(`${getViewStorePath(vGroupQuotationList)}/getAllQuotes`);

    return {
      buttonText,
      getLocalTranslation,
      onClick,
    };
  },
});
